/* eslint-disable react/prop-types */
import React from 'react';

const ButtonWithLoading = ({
  isLoading,
  text,
  loadingText,
  className = '',
  variant = 'primary',
  size = 'regular',
  outline = false,
  full = false,
  ...props
}) => {
  const buttonClasses = [
    'btn',
    `btn-${variant}`,
    `btn-${size}`,
    outline ? 'btn-outline' : '',
    full ? 'btn-full' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      className={buttonClasses}
      disabled={isLoading || props.disabled}
      {...props}
    >
      {isLoading ? (
        <>
          <span className="btn-spinner me-2">
            <svg
              className="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
              ></path>
            </svg>
          </span>
          <span className="btn-content">{loadingText}</span>
        </>
      ) : (
        text
      )}
    </button>
  );
};

export default ButtonWithLoading;